module.exports = __webpack_public_path__ + "img/stock0.ea0de28a.png";